// extracted by mini-css-extract-plugin
module.exports = {"container":"_2oWL35eg","wrapper":"kx2tzBQ2","mdWrapper":"_3g7LoBdP","smWrapper":"_3wfcJG4q","childrenWrapper":"_3rMjDNw0","closeBtn":"jyiaAQFz"};